import { Injectable } from '@angular/core';
import { ToastrService, IndividualConfig } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private toastrSvc: ToastrService) { }

  public info(title: string, message: string, timeout?: number, showCloseButton?: boolean) {

    let toast: Partial<IndividualConfig> = {
      closeButton: showCloseButton !== undefined ? true : showCloseButton,
      timeOut: timeout !== undefined ? timeout : 0
    };

    this.toastrSvc.info(message, title, toast);
  }

  public error(title: string, message: string, timeout?: number, showCloseButton?: boolean) {

    let toast: Partial<IndividualConfig> = {
      closeButton: showCloseButton !== undefined ? true : showCloseButton,
      timeOut: timeout !== undefined ? timeout : 0
    };

    this.toastrSvc.error(message, title, toast);
  }

  public success(title: string, message: string, timeout?: number, showCloseButton?: boolean) {

    let toast: Partial<IndividualConfig> = {
      closeButton: showCloseButton !== undefined ? true : showCloseButton,
      timeOut: timeout !== undefined ? timeout : 0
    };

    this.toastrSvc.success(message, title, toast);
  }

  public warning(title: string, message: string, timeout?: number, showCloseButton?: boolean) {

    let toast: Partial<IndividualConfig> = {
      closeButton: showCloseButton !== undefined ? true : showCloseButton,
      timeOut: timeout !== undefined ? timeout : 0
    };

    this.toastrSvc.warning(message, title, toast);
  }
}
